import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// react-router keeps the scroll position across client-side navigations, so
// following a link from the bottom of one page (e.g. a "You might also like"
// card) would land you at the bottom of the next page — making the new page's
// hero look "missing" until a refresh reset scroll to 0. This resets scroll to
// the top on every path change, matching what a real page load would do.
//
// It intentionally keys on pathname only (not hash): in-page anchor links like
// /#treks or /manaslu-circuit#itinerary must keep their scroll-to-section
// behaviour, so a hash-only change is left alone.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) return               // let anchor links scroll to their target
    window.scrollTo(0, 0)
  }, [pathname, hash])

  return null
}
